import axios from "axios";

//interceptadores request
axios.interceptors.request.use((config) => {
  return config;
});

//interceptadores response

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
